export default '/build/eca24678.svg'